import { Button } from 'antd';
import styled from 'styled-components';

const NotSupportedFieldContainer = styled.div`
  background: #e7e9fd;
  height: 4em;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  gap: 5px;
  span {
    font-size: 0.9em;
    font-weight: 400;
  }
  .anticon {
    font-weight: 900;
    font-size: 1.4em;
    color: #9fa2f8;
  }
`;

const ButtonFinish = styled(Button)`
  &.ant-btn-primary[disabled] {
    background-color: rgba(252, 114, 40, 0.66) !important;
    border-color: rgba(252, 114, 40, 0.3) !important;
    color: white;
  }
`;

export { NotSupportedFieldContainer, ButtonFinish };
